import { useEffect } from "react";
import "./snow.css";

export default function Snow() {
  useEffect(() => {
    const now = new Date();
    const month = now.getMonth(); // 0 = January, 11 = December

    // Only run snow effect in December
    if (month !== 11) return;

    const container = document.querySelector(".snow-container");

    for (let i = 0; i < 40; i++) {
      const snowflake = document.createElement("div");
      snowflake.className = "snowflake";
      snowflake.innerHTML = "❄";

      snowflake.style.left = Math.random() * 100 + "vw";
      snowflake.style.animationDuration = 5 + Math.random() * 5 + "s";
      snowflake.style.fontSize = 8 + Math.random() * 12 + "px";

      container.appendChild(snowflake);
    }
  }, []);

  return <div className="snow-container"></div>;
}
